import { SumFloat } from 'sum-float'

export default {
  components: {},
  props: {
    editItem: Object,
  },
  watch: {},
  computed: {},
  methods: {
    SumFloat,
  },
  async mounted() {},
}
